import desktopImage from './desktop-image.jpg';
import desktopVideo from './desktop-video.mp4';
import mobileImage from './mobile-image.jpg';
import mobileVideo from './mobile-video.mp4';

export const assets = { desktopImage, desktopVideo, mobileImage, mobileVideo };
